/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the StaffBacklogMetric interface.
 */
export function instanceOfStaffBacklogMetric(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffBacklogMetricFromJSON(json) {
    return StaffBacklogMetricFromJSONTyped(json, false);
}
export function StaffBacklogMetricFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total': !exists(json, 'total') ? undefined : json['total'],
        'newInPeriod': !exists(json, 'newInPeriod') ? undefined : json['newInPeriod'],
    };
}
export function StaffBacklogMetricToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total': value.total,
        'newInPeriod': value.newInPeriod,
    };
}
